const contentBreakpoints = {
  xxs: '200',
  xs: '400',
  s: '600',
  m: '840',
  l: '1224',
  xl: '1824',
  xxl: '1920',
} as const

export type Breakpoint = keyof typeof contentBreakpoints
export type Columns = { [breakpoint in Breakpoint]?: number }
export default contentBreakpoints
